import { AppointmentData } from '../../interface/appointment-data';

let appointment: AppointmentData | undefined;

export const setAppointment = (data: AppointmentData): void => {
  appointment = data;
};

export const getAppointment = (): AppointmentData | undefined => appointment;
